// Lib
import React from 'react';
import ReactDOM from 'react-dom';

// Constants
import { KEY_CODES } from '../utils/keyboard/keyConstants';
import rafThrottle from '../../common/utils/lib/rafThrottle';

const isMiddleMouseButtonEvent = (event) => event && event.button === 1;

export default (DecoratedComponent) => {
    class grabScrollDecorator extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                grabEnabled: false,
                grabbing: false,
            };

            this.mouseX = 0;
            this.mouseY = 0;
        }

        componentDidMount() {
            document.addEventListener('keydown', this.onKeyDown);
            document.addEventListener('keyup', this.onKeyUp);
            document.addEventListener('mousedown', this.bodyMousedown);
        }

        componentWillUnmount() {
            document.removeEventListener('keydown', this.onKeyDown);
            document.removeEventListener('keyup', this.onKeyUp);
            document.removeEventListener('mousedown', this.bodyMousedown);
        }

        onKeyDown = (event) => {
            const { grabEnabled } = this.state;

            // If the event
            if (event.keyCode === KEY_CODES.SPACEBAR && event.target === window.document.body) {
                // TODO Try to prevent the cursor from hiding when the space bar is pressed
                event.preventDefault();
                event.stopPropagation();

                if (!grabEnabled) {
                    this.setState({ grabEnabled: true });
                }
            }
        };

        onKeyUp = (event) => {
            const { grabEnabled } = this.state;

            if (event.keyCode === KEY_CODES.SPACEBAR && grabEnabled) {
                this.setState({ grabEnabled: false, grabbing: false });
                this.bodyMouseup(event);
            }
        };

        bodyMousedown = (event) => {
            const { grabEnabled } = this.state;

            if (!(isMiddleMouseButtonEvent(event) || grabEnabled)) return;

            this.canvasViewport = ReactDOM.findDOMNode(this);
            this.mouseX = event.pageX;
            this.mouseY = event.pageY;

            this.setState({
                grabbing: true,
                mouseGrabbing: isMiddleMouseButtonEvent(event),
            });

            document.addEventListener('mouseup', this.bodyMouseup);
            document.addEventListener('mousemove', this.rafBodyMousemove);

            event.preventDefault();
            event.stopPropagation();
        };

        bodyMousemove = (event) => {
            this.canvasViewport.scrollLeft = Math.max(
                (this.canvasViewport.scrollLeft || 0) + (this.mouseX - event.pageX),
                0,
            );
            this.canvasViewport.scrollTop = Math.max(
                (this.canvasViewport.scrollTop || 0) + (this.mouseY - event.pageY),
                0,
            );

            this.mouseX = event.pageX;
            this.mouseY = event.pageY;
            event.preventDefault();
            event.stopPropagation();
        };

        rafBodyMousemove = rafThrottle(this.bodyMousemove);

        bodyMouseup = (event) => {
            this.setState({
                grabbing: false,
                mouseGrabbing: false,
            });

            this.rafBodyMousemove.cancel();

            document.removeEventListener('mousemove', this.rafBodyMousemove);
            document.removeEventListener('mouseup', this.bodyMouseup);

            event.preventDefault();
            event.stopPropagation();
        };

        render() {
            const { grabEnabled, grabbing, mouseGrabbing } = this.state;

            return (
                <DecoratedComponent
                    {...this.props}
                    grabEnabled={grabEnabled}
                    mouseGrabbing={mouseGrabbing}
                    grabbing={grabbing}
                />
            );
        }
    }

    grabScrollDecorator.propTypes = {};

    return grabScrollDecorator;
};
